import { getGeocodedLocation } from '../../../../../components/hocs/RequestLocation/LocationFetch';
import { FILTER_VALUES } from '../../constants';

const { DEFAULT_DISTANCE } = FILTER_VALUES;

export const getCurrentBrowserLocation = async ({
  auth,
  filters,
  updateLocationInput,
  setPendingLocation,
}) => {
  /**
   * Uses user's saved location as fallback
   */
  const applyUserSavedLocation = () => {
    if (auth?.user?.location?.latLng && auth.user.location.display) {
      const [lat, lng] = auth.user.location.latLng;

      // Update input field
      updateLocationInput(auth.user.location.display);

      // Set pending location data for Apply button
      const locationFilters = {
        lat,
        lng,
        location: auth.user.location.display,
        distance: filters.distance || DEFAULT_DISTANCE,
        locationCountryName: '',
        locationStateName: '',
      };
      setPendingLocation(locationFilters);
    }
  };

  // Check if geolocation is supported
  if (!navigator.geolocation) {
    console.error('Geolocation is not supported by this browser.');
    applyUserSavedLocation();
    return;
  }

  // Geolocation options with timeout and error handling
  const options = {
    enableHighAccuracy: true,
    timeout: 10000, // 10 seconds timeout
    maximumAge: 300000, // 5 minutes cache
  };

  try {
    // Get current position
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });

    const { latitude, longitude } = position.coords;

    // Geocode the coordinates to get a readable location name
    const locationObject = await getGeocodedLocation(latitude, longitude);

    // Update input field
    updateLocationInput(locationObject.location);

    // Set pending location data for Apply button
    const locationFilters = {
      lat: latitude,
      lng: longitude,
      location: locationObject.location,
      distance: filters.distance || DEFAULT_DISTANCE,
      locationCountryName: '',
      locationStateName: '',
    };
    setPendingLocation(locationFilters);
  } catch (error) {
    console.error('Error getting location:', error);

    // User-friendly error messages
    const errorMessages = {
      1: 'Location access denied. Please enable location permissions.',
      2: 'Location unavailable. Please try again.',
      3: 'Location request timed out. Please try again.',
    };

    console.log(errorMessages[error.code] || 'Unable to get your location.');

    // Fallback to user's saved location
    applyUserSavedLocation();
  }
};
